import { WidgetId } from "@/common/constants/widgetId";
import { defaultWidgets } from "@/common/constants/defaultWidgets";
import { Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import "../Homepage/Homepage.scss";
import { Button, DialogButtons, InformationalDialog, InformationalDialogActionProps } from "@chr/eds-react";
import { useTranslation } from "@chr/online-shared-ui-localizations";
import { useDispatch } from 'react-redux';
import { addWidgetInit, resetWidgets } from "@/common/actions/widgetActions";
import AddIcon from '@mui/icons-material/Add';

export const ConfigureDashboard = () => {
  const translate = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [resetDialogOpen, setResetDialogOpen] = useState<boolean>(false);
  const menuIsOpen = Boolean(anchorEl);
  const menuButtonId = 'homepage-configure-menu-button';
  const menuId = 'homepage-configure-menu';
  const dispatch = useDispatch();
  
  const addWidget = (widgetId: WidgetId) => {
    const defaultUserWidgets = defaultWidgets(window.innerWidth);
    const widget = defaultUserWidgets.find((widget) => widget.widgetId === widgetId);

    if (widget) {
      dispatch(addWidgetInit(widget));
    }
  }

  const buttons: Partial<DialogButtons<InformationalDialogActionProps>> = {
    primaryAction: {
      buttonText: translate('Yes, reset'),
      id: 'confirm-reset-action',
      type: 'button',
      onClick: () => {
        dispatch(resetWidgets());
        setResetDialogOpen(false);
      }
    },
    secondaryAction: {
      buttonText: translate('Cancel'),
      id: 'confirm-reset-cancel',
      type: 'button',
      onClick: () => {
        setResetDialogOpen(false);
      }
    }
  }

  return (
    <>
      <Button
      id={menuButtonId}
      aria-controls={menuId}
      aria-expanded={menuIsOpen}
      aria-label={'Configure Menu Button'}
      aria-haspopup='menu'
      onClick={(e: any) => setAnchorEl(e.currentTarget)}
      variant="tertiary"
      type='button'
      endIcon="expand_more"
      buttonText={translate('Configure')}
      />
      <Menu
      id={menuId}
      open={menuIsOpen}
      anchorEl={anchorEl}
      onClose={() => setAnchorEl(null)}
      anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      transformOrigin={{ horizontal: 'left', vertical: 'top' }}
      MenuListProps={{
        'aria-labelledby': menuButtonId,
      }}>
        <MenuItem
          component='button'
          key='Add content to home page'
          sx={{
            '&:hover': { backgroundColor: 'white', cursor: 'default' } 
          }}
        >
          {<span className="menu-item-header">
              {translate('Add content to home page')}
          </span>}
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            addWidget(WidgetId.Orders);
          }}
          component='button'
          key='My Orders at a Glance'
          sx={{
            width: '100%',
          }}
        >
        <span className="menu-item"><AddIcon />{translate('My Orders at a Glance')}</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            addWidget(WidgetId.RecentOrders);
          }}
          component='button'
          key='Recently Viewed'
          sx={{
            width: '100%',
          }}
        >
        <span className="menu-item"><AddIcon />{translate('Recently viewed')}</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            addWidget(WidgetId.Shipments);
          }}
          component='button'
          key='My Shipments at a Glance'
          sx={{
            width: '100%'
          }}
          divider
        >
        <span className="menu-item"><AddIcon />{translate('My Shipments at a Glance')}</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setResetDialogOpen(true);
          }}
          component='button'
          key='Reset homepage to default'
          sx={{
            width: '100%'
          }}
        >
          <span className="menu-item">{translate('Reset homepage to default')}</span>
        </MenuItem>
      </Menu>
      <InformationalDialog 
        title={translate('Are you sure you want to Reset homepage to default?')}
        bodyText={translate('The homepage will be reset if you click Yes, reset. Your data will remain the same but the homepage including widgets will be reset to the default state.')}
        open={resetDialogOpen} 
        onClose={() => {
          setResetDialogOpen(false);
        }}
        {...buttons as any}
      />
    </>
  );
};

export default ConfigureDashboard;







